import { FC, PropsWithChildren, Suspense, lazy } from "react";

import { blockchain } from "../../../settings";
import Loader from "../../UI/Loader/Loader";

// const TonConfig = lazy(() => import('./configs/TonConfig'));
// const BscConfig = lazy(() => import('./configs/BscConfig'));
const NewBscConfig = lazy(() => import('./configs/newBscConfig'));


const IndexWrapper: FC<PropsWithChildren> = ({children}) => {
	switch (blockchain) {
		case 'binance':
		case 'chromia':
			return (
				<Suspense
					fallback={<Loader transparent fullPage/>}
				>
					{/* <BscConfig>
						{children}
					</BscConfig> */}
					<NewBscConfig>
						{children}
					</NewBscConfig>
				</Suspense>
			)
		;

		/* case 'ton':
			return (
				<Suspense
					fallback={<Loader/>}
				>
					<TonConfig>
						{children}
					</TonConfig>
				</Suspense>
			)
		; */

		default: throw new Error();
	}
}

export default IndexWrapper;